import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import React, {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Modal} from '../../components/modal/modal';
import {useBill} from '../../hooks/use-bill';
import '../../styles/plaid.css';

export default function BillPage({user}) {
  const navigate = useNavigate();
  const {org_id} = useParams();
  const {
    state: {connections},
    removeConnection,
  } = useBill();

  const [edit, setEdit] = useState(false);

  const connection = connections[org_id] || {};
  const {organizations} = connection;

  return (
    <div className="page-container">
      <div
        className="flex-row justify-between"
        style={{
          display: 'flex',
          justifyContent: 'space-between', // Align table and buttons horizontally
          alignItems: 'flex-start', // Align table and button container at the top
          width: '100%',
        }}>
        <table
          style={{
            flexGrow: 1, // Table takes up the remaining space
          }}>
          <thead>
            <tr>
              <th>Organization</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {organizations?.length &&
              organizations.map(item => {
                const {orgName} = item;
                return (
                  <tr key={orgName}>
                    <td>{orgName}</td>
                    <td>{'Active'}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            marginLeft: '36px',
          }}>
          <button
            className="disconnect"
            onClick={() => {
              navigate('/dashboard');
            }}
            style={{marginBottom: '16px'}}>
            Done
          </button>
          <button
            className="disconnect"
            style={{marginBottom: '16px'}}
            onClick={() => {
              setEdit(!edit);
            }}>
            Edit
          </button>
          <button
            className="disconnect"
            onClick={async () => {
              const {success, error} = await removeConnection(org_id);

              if (success) {
                navigate('/dashboard');
              }
              if (error) {
                window.alert('Something went wrong. Try again later.');
              }
            }}>
            Disconnect
          </button>
        </div>
      </div>
      {edit && (
        <EditBillConnection
          active={edit}
          setActive={setEdit}
          connection={connection}
        />
      )}
    </div>
  );
}

const EditBillConnection = ({active, setActive, connection}) => {
  const {editConnection} = useBill();

  const [form, setForm] = useState({
    accounts_payable: connection.accounts_payable || '',
    accounts_receivable: connection.accounts_receivable || '',
    vendor_credits: connection.vendor_credits || '',
    credit_memo: connection.credit_memo || '',
  });

  const handleSubmit = async () => {
    try {
      const {success, error} = await editConnection({
        ...form,
        userName: connection.userName,
      });
      if (success) {
        setActive(false);
      }
      if (error) {
        window.alert('Something went wrong. Try again later.');
      }
    } catch (err) {
      window.alert('Something went wrong. Try again later.');
    }
  };

  return (
    <Modal active={active} setActive={setActive}>
      <div className="box flex-column">
        <IconButton
          aria-label="close"
          onClick={() => setActive(false)}
          style={{position: 'absolute', top: 8, right: 8}}>
          <CloseIcon />
        </IconButton>

        <Typography sx={{textAlign: 'center', fontSize: '22px'}}>
          Edit Connection
        </Typography>
        <div className="box">
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
              <Typography>Accounts Payable:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id="accounts_payable"
                  label="Accounts Payable"
                  placeholder="accounts_payable"
                  value={form.accounts_payable}
                  type="text"
                  onChange={evt =>
                    setForm({...form, accounts_payable: evt.target.value})
                  }
                  variant="filled"
                />
              </FormControl>
            </Grid>
          </Grid>
          <br />
          <Typography>
            Enter the Forest account name for Accounts Payable. This account is
            used to balance bill, payment out, and vendor credit data from
            Bill.com
          </Typography>
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
              <Typography>Accounts Receivable:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id="accounts_receivable"
                  label="Accounts Receivable"
                  placeholder="accounts_receivable"
                  value={form.accounts_receivable}
                  type="text"
                  onChange={evt =>
                    setForm({...form, accounts_receivable: evt.target.value})
                  }
                  variant="filled"
                />
              </FormControl>
            </Grid>
          </Grid>
          <br />
          <Typography>
            Enter the Forest account name for Accounts Receivable. This account
            is used to balance invoice, payment in, and credit memo data from
            Bill.com
          </Typography>
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
              <Typography>Vendor Credits:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id="vendor_credits"
                  label="Vendor Credits"
                  placeholder="vendor_credits"
                  value={form.vendor_credits}
                  type="text"
                  onChange={evt =>
                    setForm({...form, vendor_credits: evt.target.value})
                  }
                  variant="filled"
                />
              </FormControl>
            </Grid>
          </Grid>
          <br />
          <Typography>
            Enter the Forest account name for Vendor Credits.
          </Typography>
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
              <Typography>Credit Memo:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id="credit_memo"
                  label="Credit Memo"
                  placeholder="credit_memo"
                  value={form.credit_memo}
                  type="text"
                  onChange={evt =>
                    setForm({...form, credit_memo: evt.target.value})
                  }
                  variant="filled"
                />
              </FormControl>
            </Grid>
          </Grid>
          <br />
          <Typography>
            Enter the Forest account name for Credit Memos.
          </Typography>
          <br />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}>
          <Button
            onClick={() => setActive(false)}
            style={{
              zIndex: 1,
              backgroundColor: '#c5c7c6',
              height: '30px',
              border: '0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '16px 32px 0px 32px',
              color: 'black',
            }}>
            Close
          </Button>
          <Button
            onClick={handleSubmit}
            style={{
              zIndex: 1,
              backgroundColor: '#c5c7c6',
              height: '30px',
              border: '0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '16px 32px 0px 32px',
              color: 'black',
            }}>
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};
